<script setup lang="ts">
defineProps<{ title: string; description?: string }>();
</script>

<template>
  <div class="sidebar-card relative mt-12 rounded-lg bg-light p-6 pt-16">
    <div class="absolute -top-12 left-1/2 -translate-x-1/2 [&>*]:size-24">
      <slot name="picto" />
    </div>
    <div class="space-y-4">
      <h3 class="h4 text-center">
        {{ title }}
      </h3>
      <div v-if="description" class="paragraph-lg text-center">
        {{ description }}
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="postcss">
.sidebar-card {
  .form-wrapper .message {
    @apply text-center;
  }
}
</style>
